import type { FilterData } from '@hotjar/feedback';
import { areAllRatingsIncluded } from '@hotjar/feedback/components/Surveys/Responses/Filters/RatingFilter';
import type { GlobalFilter } from '@hotjar/global-filters';
import { RadioTextFilterOperation } from '@hotjar/global-filters';
import type { Clause, UrlOperation } from './Clause';
import { convertFromNewUiToClause } from './FilterNewUiToClause';
import { CompletionOptions, RecordingOptions } from './FilterDataType';

function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

function urlOperation(operation: RadioTextFilterOperation): UrlOperation {
  switch (operation) {
    case RadioTextFilterOperation.IS:
      return 'EQUALS';
    case RadioTextFilterOperation.CONTAINS:
      return 'CONTAINS';
    case RadioTextFilterOperation.NOT_CONTAINS:
      return 'NOT_CONTAINS';
    case RadioTextFilterOperation.STARTS_WITH:
      return 'STARTS_WITH';
    case RadioTextFilterOperation.ENDS_WITH:
      return 'ENDS_WITH';
    default:
      throw new Error();
  }
}

export function filterDataToSearchClauses(filters: FilterData[]): Clause[] {
  return filters
    .map((f): Clause | null => {
      switch (f.type) {
        case 'keyword':
          if (f.value === undefined) return null;
          return {
            type: f.type,
            value: f.value.value,
            operation: f.value.operation,
          };
        case 'url':
          if (f.value === undefined) return null;
          return {
            type: f.type,
            value: f.value.value,
            operation: urlOperation(f.value.operation),
          };
        case 'completion':
          if (f.value === undefined || f.value === CompletionOptions.ALL) return null;

          return { type: 'is_complete', value: f.value === CompletionOptions.COMPLETE };
        case 'reaction':
          if (f.value === undefined || f.value.length === 0 || areAllRatingsIncluded(f.value))
            return null;

          return {
            type: 'reaction',
            values: f.value,
          };
        case 'recording':
          if (f.value === undefined || f.value === RecordingOptions.ALL) return null;

          return { type: 'has_recording', value: f.value === RecordingOptions.CAPTURED };
        default:
          return null;
      }
    })
    .filter(notEmpty);
}

export function filtersToSearchClauses(
  localFilters: FilterData[],
  globalFilters: GlobalFilter,
): Clause[] {
  return [...filterDataToSearchClauses(localFilters), ...convertFromNewUiToClause(globalFilters)];
}
